import MapBox from "@/components/mapBox/MapBox"
import useIsMobile from "@/hooks/useIsMobile"
import MobileMapComponent from "@/components/mapBox/MobileMapBox"
import HomeBanner from "@/components/homeBanner/HomeBanner"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { Helmet } from "react-helmet-async"

//data description
const organizationSchema = {
  "@context": "https://schema.org",
  "@graph":[
    {
  "@type": "Organization",
  "@id": "https://843hub.com/#organization",
  name: "843Hub",
  url: "https://843hub.com",
  logo: "https://843hub.com/843hub-favicon/favicon.ico",
  //social media links
  sameAs: [ 
    "https://www.facebook.com/843Hub",
    "https://www.instagram.com/843hub/",
    "https://www.linkedin.com/company/843hub/",
    "https://twitter.com/843Hub",
    "https://www.youtube.com/@843hub",
  ],
  description: "Find things to do in Charleston SC, with our interactive event map. Plan your trip with different activities ranging from food, music, sports, to history, and comedy clubs.",
},
{
  "@type": "WebSite",
  "@id": "https://843hub.com/#website",
  url: "https://843hub.com",
  name: "843Hub",
  publisher: {
    "@id": "https://843hub.com/#organization"
  }
},

{
  "@type": "CollectionPage",
  "@id": "https://843hub.com/#list",
  url: "https://843hub.com/list",
  name: "List",
  publisher: {
    "@id": "https://843hub.com/#organization"
  },
  isPartOf: {
    "@id": "https://843hub.com/#website"
  }

},

{
  "@type": "CollectionPage",
  "@id": "https://843hub.com/#calendar",
  url: "https://843hub.com/calendar",
  name: "Calendar",
  publisher: {
    "@id": "https://843hub.com/#organization"
  },
  isPartOf: {
    "@id": "https://843hub.com/#website"
  }

},

{
  "@type": "AboutPage",
  "@id": "https://843hub.com/#about",
  url: "https://843hub.com/about-us",
  name: "About-Us",
  publisher: {
    "@id": "https://843hub.com/#organization"
  },
  isPartOf: {
    "@id": "https://843hub.com/#website"
  }
},

]};

const HomePage = () => {
  const isMobile = useIsMobile()
  const location = useLocation()

  useEffect(() => {
    if (isMobile && location.pathname === "/") {
      document.body.style.position = "fixed" // Prevents page movement
      document.body.style.width = "100%"
    } else {
      document.body.style.position = ""
      document.body.style.width = ""
    }

    const handleScroll = () => {
      if (!isMobile) {
        window.removeEventListener("scroll", handleScroll)
        document
          .getElementById("next-section")
          ?.scrollIntoView({ behavior: "smooth" })
      }
    }

    if (!isMobile) {
      window.addEventListener("scroll", handleScroll)
    }

    return () => {
      window.removeEventListener("scroll", handleScroll)
      document.body.style.position = ""
      document.body.style.width = ""
    }
  }, [isMobile, location.pathname])
  return (
    <>
      {isMobile ? <></> : <HomeBanner />}

      <Helmet>
        <title>843Hub | Things to do in Charleston | Event Map</title>
        <meta
          name="description"
          content="Discover the best things to do in Charleston with our interactive map. Plan Charleston trip with food, community, music, sports, history. Explore Charleston Map."
        />
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)} 
        </script>
      </Helmet>
      <div
        id="next-section"
        style={
          isMobile ? {} : { display: "flex", width: "100%", height: "100%" }
        }
      >
        {isMobile ? <MobileMapComponent /> : <MapBox />}
      </div>
    </>
  )
}

export default HomePage
